exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".support blockquote{margin:5px 0 10px;font-size:13px;font-style:italic;padding:5px;color:gray}.support .alert-dismissable{margin-top:10px}.v--modal{height:600px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-bd99ae80!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Support/index.vue
// module id = 931
// module chunks = 2